import { m } from 'framer-motion';
import { Box, Button, Container, Stack, styled, Typography } from '@mui/material';
import React from 'react';
import { MotionViewport, TextAnimate, varFade } from '../../components/animate';
import { downloadFile } from '../../utils/downLoad';
import { Link as RouterLink } from 'react-router-dom';

const RootStyle = styled('div')(({ theme }) => ({
  position: 'relative',
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(5, 0),
  },
}));

const docUrl =
  'https://firebasestorage.googleapis.com/v0/b/apizf-site.appspot.com/o/YEARBOOK-TOGO-2022-2023-English.pdf?alt=media&token=cafcc6d8-6bb6-48f5-ad6d-f881650011a9';
const docTitle = 'YEARBOOK TOGO 2022-2023 Economic Report';

export default function HomeDocument() {
  return (
    <RootStyle>
      <Stack width={1} alignItems="start">
        <Stack width={{ xs: 1, md: 0.65 }} py={{xs: 5}}>
          <m.div animate={{ y: [-20, 0, -20] }} transition={{ duration: 4, repeat: Infinity }}>
            <Box component={m.img} src="/assets/background/yearbook.png" height={1} width={1} />
          </m.div>
        </Stack>
      </Stack>

      <Stack position={{ md: 'absolute' }} top={0} left={0} bottom={0} right={0} justifyContent="center">
        <Container>
          <Stack width={1} alignItems="flex-end" justifyContent="center">
            <Stack component={MotionViewport} width={{ xs: 1, md: 0.5 }} pr={{ md: 10 }}>
              <TextAnimate addspace variants={varFade().inRight} component="h2" text="YEARBOOK" color="primary.main" />
              <TextAnimate
                addspace
                variants={varFade().inRight}
                component="h2"
                text="TOGO 2022-2023"
                color="primary.main"
              />
              <TextAnimate
                addspace
                variants={varFade().inRight}
                component="h2"
                text="Economic Report"
                color="primary.main"
              />
              <Box
                component={m.div}
                variants={varFade().inRight}
                mb={3}
                height={10}
                width={100}
                bgcolor="primary.main"
              />
              <m.div variants={varFade().inRight}>
                <Typography mb={3} textAlign="justify">
                  La Ministre Togolaise de l'Investissement, Rose Kayi Mivedor, a dévoilé mardi l'Annuaire du Togo
                  2022-2023, un rapport économique présentant le potentiel économique du pays, comme un outil pour
                  attirer les Investissements directs étrangers (IDE).
                </Typography>
              </m.div>

              <Stack direction="row" spacing={1} mb={3} component={m.div} variants={varFade().inRight}>
                <DotElement />
                <DotElement />
                <DotElement />
              </Stack>
              <m.div>
                <Stack component={m.div} variants={varFade().inUp} width={1} direction="row" spacing={{ xs: 2, md:5}} >
                  <Button
                    variant="contained"
                    color="warning"
                    sx={{ color: '#FFF', fontWeight: 'bold', borderRadius: 5, padding:{ xs: '6px 8px', md: '6px 16px' }}}
                    onClick={() => downloadFile(docUrl, docTitle)}
                  >
                    Télécharger
                  </Button>
                  <Button
                    component={RouterLink}
                    to="/documents"
                    variant="contained"
                    color="error"
                    sx={{ color: '#FFF', fontWeight: 'bold', borderRadius: 5 }}
                  >
                    Télécharger des documents
                  </Button>
                </Stack>
              </m.div>
            </Stack>
          </Stack>
        </Container>
      </Stack>
    </RootStyle>
  );
}

const DotElement = () => <Box height={10} width={10} borderRadius={20} bgcolor="primary.main" />;
